import axios from 'axios';
import url from '@jumbo/constants/UrlConstant';

export default axios.create({
  baseURL: url.baseUrl, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
  },
});
